// extracted by mini-css-extract-plugin
export default {"wrapper":"TopicsList_wrapper__i2-KY","topic":"TopicsList_topic__rXAap"};